import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import TotalNoOfReports from "../../../Dashboard/ogmDashboard/TotalNoOfReports";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { assessmentReportTableHeader } from "../../../../components/datagrid/myworkspace/ogd/OGAAssessmentReports/assessmentReportTableHeader";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { useLocation, useNavigate } from "react-router-dom";
import { getOGADoneAssessments } from "../../../../redux/features/OgdDashboard";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import FromAndToDatePicker from "../../../../components/mui/FromAndToDatePicker";
import useResponsive from "../../../../Hooks/useResponsive";
import ActionDetails from "../../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../../components/mui/GlobalAnchor/GlobalAnchorList";
import InduvidualAssessmentReport from "../../../assessmentReportInduvidual/InduvidualAssessmentReport";
import { Icon } from "@iconify/react";
import ProgressBar from "../../../../components/mui/ProgressBar";
import GlobalSelectFieldWithoutFormikNew from "../../../../components/mui/GlobalSelectFieldWithoutFormikNew";
const selectionData = [
   { id: 1, value: "None" },
  { id: 2, value: "Assessment Based" },
];
const OGAWiseReport = () => {
  const navigate = useNavigate("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const ogaIdParams = searchParams.get("id");
  const fromDateParam = searchParams.get("fromDate");
  const toDateParam = searchParams.get("toDate");
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, resData } = useSelector((store) => store.ogdDashboard);
  const { data, meta } = resData;
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(
    fromDateParam || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    toDateParam || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");
  const dateFilterCriteriaParams = searchParams.get("filterCriteria");
  const [selectedDateCriteria, setSelectedDateCriteria] = useState(
    dateFilterCriteriaParams
      ? selectionData.find((data) => data.id == dateFilterCriteriaParams)
      : { id: 1, value: "None" },
  );
  const dispatchParams = {
    paginationData,
    ogaIdParams,
    fromDate,
    toDate,
    selectedDateCriteria
  };

  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);

  useEffect(() => {
    if (paginationData.pageNum && paginationData.gridSize) {
      dispatch(getOGADoneAssessments(dispatchParams));
    }
  }, [fromDate, toDate, gridSize, pageNum, search,selectedDateCriteria]);
  const progressBar = {
    target: 100000,
    achievedTarget: 80000,
    slot: 2000,
    achievedSlot: 100,
  };
  const UnconfirmedNavigation = () => {
    console.log("oga id pass and navigation");
  };

  return (
    <GlobalWrapper title={"Assessment Report"}>
      <Stack gap={1} direction={direction}>
        <Box sx={{ flex:0.5 }}>
          <FromAndToDatePicker
          fullWidth={true}
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <GlobalSelectFieldWithoutFormikNew
            keys={{ itemId: "id", itemValue: "value" }}
            data={selectionData}
            label={"Date Filter Criteria"}
            fullWidth={true}
            selectedDetails={selectedDateCriteria}
            setChange={setSelectedDateCriteria}
          />
        </Box>
       
      </Stack>

      <Box mt={1}>
          <TotalNoOfReports
            assessmentTaken={data?.count?.assessmentCount}
            reportGenerated={data?.count?.reportCount}
            totalCourseEnrollmentCount={data?.count?.totalCourseEnrollmentCount}
            totalAdmissionCount={data?.count?.admissionCount}
            totalArpu={data?.count?.totalArpu}
            totalAcr={data?.count?.totalAcr}
            totalTar={data?.count?.totalTar}
            totalSfr={data?.count?.totalSfr}
            // top={data?.count?.topUserNames}
            saleAmount={data?.count?.totalTotalFees}
            revenue={data?.count?.totalRevenue}
            admissionNotConfirmed={data?.count?.totalUnenrolledCount}
            navigateFunction={UnconfirmedNavigation}
          />
        </Box>
      <Box
        mt={1}
        p={1}
        sx={{
          background:
            "linear-gradient(135deg,rgba(0, 139, 208, 0.79),rgba(160, 37, 194, 0.74))",
          borderRadius: 3,
        }}
      >
        <Stack gap={1} direction={direction}>
          <ProgressBar
            achieved={{
              name: "Achieved",
              value:  data?.count?.totalRevenue,
            }}
            target={{ name: "Target", value: data?.count?.totalTarget }}
          />
          <ProgressBar
            achieved={{ name: "Slot", value: data?.count?.totalCourseEnrollmentCount }}
            target={{ name: "Slot Goal", value: data?.count?.totalSlot }}
          />
        </Stack>
      </Box>
      <Box mt={1}>
        <Paper elevation={1}>
          <GlobalDatagrid
            tableHead={assessmentReportTableHeader(navigate)}
            rows={data?.leads || []}
            meta={meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.name} />
                {rowData?.isAssessmentTaken == "YES" && (
                  <GlobalAnchorList
                    component={
                      <InduvidualAssessmentReport
                        sx={{
                          p: "7px",
                          background:
                            "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(160, 37, 194, 0.74))",
                          color: "#fff",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, rgb(0, 49, 208), rgb(171, 37, 194))",
                          },
                        }}
                        leadId={rowData?.leadId}
                        buttonName={"View Assessment Report"}
                        btnIcon={<Icon icon="mdi:eye" width="20" height="20" />}
                      />
                    }
                  />
                )}
                <GlobalAnchorList
                  component={
                    <Box>
                      <Button
                        sx={{
                          p: "7px",
                          px: "10px",
                          background:
                            "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(160, 37, 194, 0.74))",
                          color: "#fff",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, rgb(0, 49, 208), rgb(171, 37, 194))",
                          },
                        }}
                        onClick={() =>
                          navigate(`/assessment-tool/student-registration`)
                        }
                        variant="outlined"
                      >
                        <Icon
                          icon="mingcute:user-search-fill"
                          width="20"
                          height="20"
                        />
                        Go To Take Assessment
                      </Button>
                    </Box>
                  }
                />
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default OGAWiseReport;
